import ApiService from "@/services/ApiService";

const REPOSITORY_URL = "cuenta";

const CuentaRepository = {
  detalle(idCuenta, periodo) {
    let data = {
      idCuenta,
      periodo,
    };
    return ApiService.get(`${REPOSITORY_URL}/detalle`, data);
  },
  resumen(idCuenta, periodo) {
    let data = {
      idCuenta,
      periodo,
    };
    return ApiService.get(`${REPOSITORY_URL}/resumen`, data);
  },
  resumenAnual(idCuenta, anio) {
    let data = {
      idCuenta,
      anio,
    };
    return ApiService.get(`${REPOSITORY_URL}/resumen_anual`, data);
  },
  extracto(idCuenta, periodo) {
    let data = {
      idCuenta,
      periodo,
    };
    return ApiService.download(`${REPOSITORY_URL}/extracto`, data);
  },
  historialSaldo(idCuenta) {
    let data = {
      idCuenta,
    };
    return ApiService.get(`${REPOSITORY_URL}/historial_saldos`, data);
  },
};

export default CuentaRepository;
